import { useId } from 'react';
import { useFormikContext } from 'formik';
import { useTranslation } from 'react-i18next';
import SolarSunriseLinear from 'components/icons/SolarSunriseLinear';
import SolarWalletMoneyLinear from 'components/icons/SolarWalletMoneyLinear';
import SolarToolboxLinear from 'components/icons/SolarToolboxLinear';

export interface ReportKindValues {
    includeObjects: boolean;
    includeSales: boolean;
    includeServiceSales: boolean;
}

const ReportKindCheckboxes = ({ showSales }: { showSales: boolean }) => {
    const { t } = useTranslation('Reports');
    const { values, setFieldValue } = useFormikContext<ReportKindValues>();
    const id = useId();
    const options = [
        { field: 'includeObjects', label: 'objects', Icon: SolarSunriseLinear },
        ...(showSales ? [
            { field: 'includeSales', label: 'sales', Icon: SolarWalletMoneyLinear },
            { field: 'includeServiceSales', label: 'serviceSales', Icon: SolarToolboxLinear },
        ] : []),
    ] as const;
    return (
        <div className="mb-3 d-flex gap-1">
            {options.map(({ field, label, Icon }) => (
                <label
                    key={field}
                    htmlFor={`${id}-${field}`}
                    className={`d-flex align-items-center justify-content-center gap-1 flex-grow-1 border rounded-2 p-2 mb-0 text-body ${values[field as keyof ReportKindValues] ? 'bg-primary-subtle border-primary-subtle' : 'bg-body'}`}
                    style={{ flexBasis: 0, minWidth: 0 }}
                >
                    <input
                        id={`${id}-${field}`}
                        type="checkbox"
                        className="form-check-input m-0 flex-shrink-0"
                        checked={values[field as keyof ReportKindValues]}
                        onChange={(event) => void setFieldValue(field, event.currentTarget.checked)}
                    />
                    <Icon width={14} height={14} className="flex-shrink-0 text-muted" />
                    <span className="fs-12 text-wrap">{t(`reportFilter.${label}`)}</span>
                </label>
            ))}
        </div>
    );
};

export default ReportKindCheckboxes;
